const events = [
  {
    month: 'EXPERIENCE',
    title: 'Local Markets and Events',
    description: 'Discover the vibrant events hosted throughout the Tamar Valley, featuring seasonal wine festivals, local food markets, heritage tours, and cultural celebrations',
    image: '/images/exeter-market.jpg',
  },
];

export function EventsSection() {
  return (
    <section id="events" className="py-40 px-6 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto space-y-32">
        {/* Header */}
        <div className="text-center space-y-8 animate-fade-in">
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-[0.1em] sm:tracking-[0.15em] md:tracking-[0.2em] text-secondary/80 break-words px-4">
            EVENTS
          </h2>
        </div>

        {/* Events Grid */}
        <div className="space-y-24">
          {events.map((event, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-10 gap-12 items-center animate-slide-in-sequence ${
                index % 2 === 0 ? '' : 'lg:grid-flow-dense'
              }`}
              style={{ animationDelay: `${index * 200}ms` }}
            >
              {/* Text Content - 3 columns */}
              <div className={`lg:col-span-3 space-y-8 ${index % 2 === 0 ? '' : 'lg:col-start-8'}`}>
                <p className="text-xs tracking-[0.4em] text-secondary/40 uppercase">
                  {event.month}
                </p>
                
                <h3 className="text-4xl tracking-[0.15em] text-secondary/70">
                  {event.title}
                </h3>

                <p className="text-sm leading-relaxed text-white/50 tracking-wide">
                  {event.description}
                </p>

                <a 
                  href="/events" 
                  className="inline-block text-xs tracking-[0.3em] text-secondary/60 hover:text-secondary transition-all duration-500 uppercase group"
                >
                  Discover
                  <span className="inline-block ml-2 group-hover:translate-x-2 transition-transform duration-500">→</span>
                </a>
              </div>

              {/* Image - 7 columns */}
              <div className={`lg:col-span-7 ${index % 2 === 0 ? '' : 'lg:col-start-1 lg:row-start-1'}`}>
                <div className="relative overflow-hidden aspect-[16/10] bg-black/20 group">
                  <a href="/events">
                    <img
                        src={event.image}
                        alt={event.title}
                        className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-1000"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
